import { getSession, getStatusColor } from "../../helpers";
import { getHeaderData } from "../../apis/accountWorker";
import {
  DEFAULT_PROFILE_PHOTO,
  PROFILE_TIMESTAMP_STORAGE_KEY,
  USER_PHOTO_STORAGE_KEY,
} from "../../settings";

const euiNotificationsCenter = () => $("eui-notifications-center");

$(() => {
  const session = getSession();

  if (session) {
    $(".user-name-submenu").text(
      [session.name, session.firstName, session.lastName].join(" ")
    );
    $(".user-user-submenu").text(session.email);

    getHeaderData()
      .done((): void => {
        const headerData = JSON.parse(
          localStorage.getItem(PROFILE_TIMESTAMP_STORAGE_KEY) ?? ""
        );
        const hasNotifications = headerData.pendingNotifications;
        if(hasNotifications) euiNotificationsCenter().attr("hasNotifications", hasNotifications);

        window.addEventListener('resize', function(event: any) {
          const target = event.target!;
          const width = target.innerWidth;
          let arrowRightPosition = "0px";
          if(width > 1675) arrowRightPosition = "318px";
          else if(width > 1165) arrowRightPosition = "54%";
          else if(width > 767) arrowRightPosition = "36%";

          euiNotificationsCenter().attr("rightArrowPosition", arrowRightPosition);
        }, true);
      

        $("#userBullet path")
          .css("stroke", getStatusColor(headerData.globalPercentage))
          .css("stroke-dasharray", `${headerData.globalPercentage}, 100`);

        $("#user-menu .profile").append(`
            <div class="psf-badge" style="background-color:${getStatusColor(
              headerData.globalPercentage
            )};">
                ${headerData.globalPercentage}%
            </div>
        `);

        const profilePhoto = localStorage.getItem(USER_PHOTO_STORAGE_KEY);

        $(".radio-progress-bar__image").attr(
          "xlink:href",
          profilePhoto
            ? `data:image/gif;base64,${profilePhoto}`
            : DEFAULT_PROFILE_PHOTO
        );
      })
      .fail(() => {
        console.error(`Error getHeaderData`);
      });
  }
});
